module.exports = "/_next/static/images/03aed6c1fd54c0f71cf75c8333f7769a-image-left-xs.jpg.webp";